import { CrossAxisAlignment, MainAxisAlignment, StackDirection } from './Enums'

export type StackPadding = {
  top: number
  right: number
  bottom: number
  left: number
}

export enum StackingOrder {
  FirstOnTop = 'firstOnTop',
  LastOnTop = 'lastOnTop',
}

export type StackProperties = {
  direction: StackDirection
  gap: number
  mainAxisAlignment: MainAxisAlignment
  crossAxisAlignment: CrossAxisAlignment
  alignContent: MainAxisAlignment
  crossAxisGutterGap: number
  padding: StackPadding
  wrappingEnabled: boolean
  stackingOrder: StackingOrder
  bordersAffectLayout: boolean
}
